require("./axios");

require("./mobile/react-native-link");

require("./hybrid-forms");

require("./alpine/alpine");
require("./alpine/alpine-search");
require("./alpine/alpine-tippy");

import sort from "@alpinejs/sort";
Alpine.plugin(sort);

require("./alpine/alpinejs-ui-3_13_8-beta.min.js");

require("../../vendor/wire-elements/pro/resources/js/overlay-component.js");

require("./helpers");

import Choices from "choices.js";
window.Choices = Choices;

window.moment = require("moment");
moment.locale("nl");

import flatpickr from "flatpickr";

const Dutch = require("flatpickr/dist/l10n/nl.js").default.nl;
flatpickr.localize(Dutch);
flatpickr.l10ns.default.firstDayOfWeek = 1; // Monday
require("flatpickr/dist/themes/airbnb.css");

import { get, filter, merge } from "lodash-es";
window._ = {
  get,
  filter,
  merge,
};

require("./draggable");
require("./toast");

import { install } from "@github/hotkey";
document.addEventListener("DOMContentLoaded", function () {
  // Install all the hotkeys on the page
  for (const el of document.querySelectorAll("[data-hotkey]")) {
    install(el);
  }
});

require("./tinymce/tinymceConfig");
window.dynamicTinymce = {
  init: async (config) => {
    if (!window.tinymce) {
      document.querySelectorAll(".tinymce").forEach(function (node) {
        node.style.opacity = 0;
      });
    }
    await import(/* webpackChunkName: "js/tinymce" */ "./tinymce/index");
    tinymce.init(config);
  },
};

class ValidationErrors {
  constructor(response) {
    this.response = response;
  }

  toList() {
    let validationMessage = "<ul>";
    let errors = this.response.errors;

    for (var key in errors) {
      if (errors.hasOwnProperty(key)) {
        for (var message in errors[key]) {
          if (errors[key].hasOwnProperty(message)) {
            validationMessage += `<li>${errors[key][message]}</li>`;
          }
        }
      }
    }
    validationMessage += "</ul>";
    return validationMessage;
  }
}

// Enable alpine listner
document.addEventListener("alpine:init", () => {
  Alpine.directive("radar-chart", async (el, { expression }, { evaluate }) => {
    if (!window.d3) {
      await import(/* webpackChunkName: "js/d3" */ "./d3.js");
      await import(
        /* webpackChunkName: "js/charts/radar-chart" */ "./charts/radar-chart/radar-chart.js"
      );
    }
    evaluate(expression);
  });

  Alpine.directive("duplicate-trigger", async (el, { expression }) => {
    el.addEventListener("input", () => {
      oninputSearchTrigger(el);
    });
  });

  Alpine.directive("duplicate-trigger-blur", async (el, { expression }) => {
    el.addEventListener("blur", () => {
      oninputSearchTrigger(el);
    });
  });

  Alpine.magic("clipboard", () => {
    let clipboard = navigator.clipboard;
    if (!clipboard) {
      console.log("clipboard is only supported in secure (https) contexts");
      return () => {};
    }

    return (subject) => navigator.clipboard.writeText(subject);
  });

  Alpine.magic("toast", () => {
    return (params) =>
      toast(params.message, params.type, { position: "right" });
  });
});

window.RegiCare = window.RegiCare || {};
window.RegiCare.ValidationErrors = ValidationErrors;
